import React from 'react';
import styled from 'styled-components';
import SkapaTooltip from 'ui/Tooltip/SkapaTooltip';
import SkapaButton from 'ui/Button/Button';

const IconButton = styled.button`
  position: relative;
  appearance: none;
  border: 0;
  background: transparent;
  padding: ${props => props.theme.space.xxs};
  cursor: pointer;

  ::before {
    content: '';
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: ${props => props.theme.colors.feedback.information};
    border-radius: 50%;
    opacity: 0;
    transform: scale(0.35);
    transition: all 0.16s ease-in-out;
  }

  :hover::before {
    opacity: 1;
    transform: scale(0.8);
  }

  svg {
    display: block;
    color: ${props => props.theme.colors.white};
  }

  :hover svg {
    color: ${props => props.theme.colors.white};
  }

  &[disabled='true'],
  &[disabled='disabled'],
  :disabled {
    pointer-events: none;
  }

  &[disabled='true'] svg,
  &[disabled='disabled'] svg,
  :disabled svg {
    opacity: 0.5;
  }
`;

type ContextButtonProps = React.PropsWithoutRef<JSX.IntrinsicElements['button']> & {
  children: React.ReactNode;
  label?: string;
  ssrIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  onClick?: (...args: any[]) => any;
  ariaHidden?: boolean;
  dataTestId?: string;
  size?: 'xsmall' | 'small' | 'medium';
};

export const ContextButton = ({
  children,
  ssrIcon,
  onClick,
  label,
  disabled,
  ariaHidden,
  dataTestId,
  size,
  ...props
}: ContextButtonProps) => {
  return label ? (
    <SkapaTooltip tooltipText={label} position="top" interactiveCustomTrigger>
      <SkapaButton
        iconOnly
        size={size}
        ssrIcon={ssrIcon}
        onClick={onClick}
        type="tertiary"
        aria-hidden={ariaHidden}
        inverseTheme
        disabled={disabled}
        dataTestId={dataTestId}
        className={props.className}
      >
        {children}
      </SkapaButton>
    </SkapaTooltip>
  ) : (
    <IconButton {...props} disabled={disabled}>
      {children}
    </IconButton>
  );
};

export default ContextButton;
